"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledContainer = styled_components_1.default.div `
  align-items: center;
  background: white;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: visible;
  height: 100%;
  width: 90%;
  margin: 5% auto;

  @media (min-height: 800px) {
    justify-content: center;
  }

  @media ${config_1.device.laptop} {
    width: 40%;
    height: 100%;
  }
`;
